export default {
  label: 'Send to',
  counter: '{{current}} of {{max}}',
  default_badge: 'Default',
  remove: 'Remove {{email}}',
  add_back: 'Add back',
  empty: 'Add at least one email.',
  add_label: 'Add an email',
  placeholder: 'name@example.com',
  add: 'Add',
  hint: 'Up to {{max}} emails. Each one gets its own email.',
  hint_full: "That's the most this list can have. Remove an email to add another.",
  errors: {
    full: 'You can add at most {{max}} emails.',
    invalid: 'Enter an email like name@example.com.',
    duplicate: '{{email}} is already on the list.',
  },
};
